import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23be9553"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "banner-overlay" }
const _hoisted_3 = { class: "form-body" }
const _hoisted_4 = { class: "form-field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "roomCode",
  class: "form-label"
}, "Room Code", -1))
const _hoisted_6 = { class: "form-input" }
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Your Name", -1))
const _hoisted_9 = { class: "form-input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-controls" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Join Game")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "form-rejoin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoSVG = _resolveComponent("LogoSVG")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LogoSVG, { class: "logo" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.joinSession && _ctx.joinSession(...args)), ["prevent"])),
        autocomplete: "off"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                id: "roomCode",
                maxlength: "6",
                pattern: "[a-zA-Z\\d]{6}",
                required: "",
                type: "text",
                class: "room-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.roomCode) = $event)),
                autocapitalize: "characters"
              }, null, 512), [
                [_vModelText, _ctx.model.roomCode]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                id: "name",
                required: "",
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.name) = $event)),
                maxlength: "20"
              }, null, 512), [
                [_vModelText, _ctx.model.name]
              ])
            ])
          ])
        ]),
        _hoisted_10,
        (_ctx.rejoinId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-link",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rejoinSession && _ctx.rejoinSession(...args)))
              }, " Rejoin Last Game ")
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ])
  ]))
}